import { Select, Space } from "antd";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";

const { Option } = Select;

const GroupFilter = (props) => {
  // props.onChange --> function in parent component to call when group is selected/deselected
  // props.teamId --> teamId used to fetch groups for team

  const supabase = getSupaClient();
  const [selectedGroup, setSelectedGroup] = useState(
    props.selected ? props.selected : ""
  );
  const [groups, setGroups] = useState([]);
  console.log("teamId:", props.teamId);
  console.log("groups:", groups);

  /**
   * This will load all the groups for a given team
   */
  const loadGroups = async () => {
    console.log("Loading groups...");
    const { data, error } = await supabase
      .from("slack_user_groups")
      .select("slack_id, name")
      .eq("team", props.teamId);
    if (data) {
      setGroups(data);
    }
    if (error) {
      console.log("Error fetching slack_user_groups", error);
    }
  };

  useEffect(() => {
    loadGroups();
  }, []);

  /**
   * This will update the selected groups each time the user clicks on one
   * in the groups selection modal
   *
   * @param {*} selection - the selected group by the user
   */
  const onSelect = async (selection) => {
    setSelectedGroup(selection);
    if (props.groupJoin) {
      const selected = groups.find((item) => item.slack_id === selection);
      props.onChange({
        user_group: {
          name: selected.name,
          id: selected.slack_id,
        },
      });
    } else if (props.onChange) {
      props.onChange({
        filter_type: "user_group",
        filter_settings: { user_group: selection },
      });
    }
  };

  /**
   * This will update the selected groups anytime the user deselects one
   * in the groups selection modal
   *
   * @param {*} selection - The selected group
   */
  const onDeselect = async () => {
    setSelectedGroup("");
    if (props.groupJoin) {
      props.onChange({});
    } else if (props.onChange)
      props.onChange({
        filter_type: "user_group",
      });
  };

  return (
    <>
      <Space>
        <span>Select group: </span>
        <Select
          showSearch
          showArrow
          value={selectedGroup}
          style={{ width: "500px", borderRadius: 10 }}
          onSelect={onSelect}
          onDeselect={onDeselect}
          optionFilterProp="name"
        >
          {groups.map((item) => {
            return (
              <Option
                key={item.slack_id}
                value={item.slack_id}
                name={item.name}
              >
                {item.name}
              </Option>
            );
          })}
        </Select>
      </Space>
    </>
  );
};

export default GroupFilter;
